module.exports = __webpack_public_path__ + "media/images/flags/mq-9f64a5ddae1c43fa3c9383ff5a95c750.svg";